import type { Post } from '@/types'
import Link from 'next/link'
import type { Settings } from 'react-slick'
import Slider from '../Slider/Slider'
import BlogCard from './BlogCard'

interface Props {
  tips: Post[]
  promotions: Post[]
}

const HomePageBlogList = ({ tips, promotions }: Props) => {
  const settings: Settings = {
    arrows: true,
    slidesToShow: 3,
    speed: 800,
    autoplay: false,
    autoplaySpeed: 5000,
  }

  return (
    <section className='blogList'>
      <div className='head-sec relative ml-auto mr-auto text-center'>
        <div className='flex gap-4'>
          <div className='w-[calc(50%-8px)] rounded-lg bg-white p-5'>
            <div className='flex items-start justify-between px-1'>
              <h4 className='mb-4 text-HeadlineMedium font-bold'>Khuyến mãi</h4>
              <Link href='/post/khuyen-mai' className='mt-[4px] text-primary'>
                Xem tất cả
              </Link>
            </div>
            <Slider {...settings} infinite={promotions?.length > 3}>
              {(promotions || []).map((post, index) => (
                <div key={index} className='px-2'>
                  <BlogCard post={post} />
                </div>
              ))}
            </Slider>
          </div>

          <div className='w-[calc(50%-8px)] rounded-lg bg-white p-5'>
            <div className='flex items-start justify-between px-1'>
              <h4 className='mb-4 text-HeadlineMedium font-bold'>Mẹo vặt</h4>
              <Link href='/post/meo-vat' className='mt-[4px] text-primary'>
                Xem tất cả
              </Link>
            </div>
            <Slider {...settings} infinite={tips?.length > 3}>
              {(tips || []).map((post, index) => (
                <div key={index} className='px-2'>
                  <BlogCard post={post} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomePageBlogList
